import React from "react";
import NoData from "@/components/NoData";
import DataRecentLineup from "../DataRecentLineup";
import CollapsiblePanel from "../CollapsiblePanel";

import { useMatchInfo } from "../ThongTinTranDau/MatchInfoContext";

export default function RecentLineup() {
  const { match, lineup } = useMatchInfo();

  if (!match || !lineup) {
    return <NoData />;
  }

  return (
    <CollapsiblePanel
      title="Đội hình gần đây"
    >
      <DataRecentLineup lineupData={lineup} match={match} />
    </CollapsiblePanel>
  );
}
